import { Component } from '@angular/core';
import { pageName } from 'src/app/shared/services/page.service';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { SourcingOutcomeInformation, VendorsList, SourcedItem, QuotationAttachment, RFQSummaryRole } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, lastValueFrom, map, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { incrementLoading, decrementLoading } from 'src/app/core/store/loading.action';
import {
  DropDownOptions,
  ExtendedKeycloakUser,
  StoreDropdowns,
  UserInformation
} from 'src/app/shared/models/app-models';
import { ReassignDialogComponent } from './reassign-dialog/reassign-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CompleteDialogComponent } from './complete-dialog/complete-dialog.component';
import {
  resetDocument,
  updateDocumentStatusId,
  UpdatePOCreated,
  updateRFQSummaryData
} from 'src/app/core/store/rfqSummary.action';
import { RfqInfoDialogComponent, RfqInfoDialogType } from './shared/rfq-info-dialog/rfq-info-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PurchaseExecutives } from 'src/app/shared/models/database-models/PurchaseExecutives.model';
import { LoadingState } from 'src/app/core/store/loading.reducer';
import { MPMMSInformation } from 'src/app/shared/models/app-models/MPMMSInformation.model';
import { PurchaseGroup } from 'src/app/shared/models/app-models/PurchaseGroup.model';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';


export interface SummaryDropdown {
  Id: number;
  Name: string;
}
export interface dataFromPrevious {
  MPDocumentNumber: string;
  RFQNumber: string;
  fromRoute: string;
}
export interface StatusData {
  rfqSummaryNum: string;
  assignedPE: string;
  status: string;
  rfqNum: string;
  requestingOfficer: string;
  createdBy: string;
  documentNo: string;
  submittedOn: Date;
  SecurityClassIdExt: string;
}

export interface ReasonForNoQuotaionItem {
  Code: string;
  Reason: string;
  IsActive: boolean;
  ValidFrom: string;
  ValidTo: string;
  ID: number;
}
@Component({
  selector: 'app-rfq-summary',
  templateUrl: './rfq-summary.component.html',
  styleUrls: ['./rfq-summary.component.scss']
})

export class RfqSummaryComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  user!: UserInformation;
  summaryData!: SourcingOutcomeInformation;
  breadCrumbFlow: string[] = [];
  activePage: string = pageName.Create_RFQ_Summary;
  dataFromPrevious!: dataFromPrevious;
  private userListSubject = new BehaviorSubject<ExtendedKeycloakUser[]>([]);  // Empty array initially
  userList$ = this.userListSubject.asObservable();
  userList: ExtendedKeycloakUser[] = [];
  statusData: StatusData = {
    rfqSummaryNum: '',
    assignedPE: '',
    status: '',
    rfqNum: '',
    requestingOfficer: '',
    createdBy: '',
    documentNo: '',
    submittedOn: new Date(),
    SecurityClassIdExt: ''
  };
  vendorList: VendorsList[] = [];
  reasonForNoQuotation: DropDownOptions[] = [];
  ReasonForAbortionDropDown: SummaryDropdown[] = [];
  itemsData!: SourcedItem[];
  isSourcingOutcomeHasError: boolean = false;
  isVendorDocumentHasError: boolean = false;

  isReadOnlyRFQSummary: boolean = false; // Manually change the status here first to toggle ReadOnly true/false.
  rfqSummaryNumber: string = '';
  MPDocumentNumber: string = '';
  RFQNumber: string = '';

  loggedInUser!: UserInformation;
  userRoleOnRfqSummary: string = '';
  RFQSummaryRole = RFQSummaryRole;
  canRecallRFQSummary: boolean = true;

  isAllItemsHavePO: boolean = false; //this boolean variable is to track whether all the MP Items in a RFQ summary has PO, which will then show two different dialog windows.
  rfqItems: SourcedItem[] = [];
  roName$: Observable<string>;
  peName$: Observable<string>;
  rfqSummary$: Observable<SourcingOutcomeInformation>;
  rfqSummaryDetails: SourcingOutcomeInformation = {} as SourcingOutcomeInformation;
  private loadingSubscription: Subscription = new Subscription();
  isLoading = false;
  isUserPE: boolean = false;

  purchaseOrderGroups: PurchaseGroup[] = [];
  mpMmsInformation: MPMMSInformation[] = [];
  vendorsHavingExpiredQuote: string[] = [];
  loadingMessage: string = '';

  constructor(
    private dialog: MatDialog,
    private location: Location, private router: Router, private BackendApi: BackendApiService,
    private store: Store<{ dp: StoreDropdowns, user: UserInformation, rfqSummary: SourcingOutcomeInformation, loading: LoadingState }>,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private keycloakService: KeycloakService
  ) {
    // Subscribe to the global loading state to track if any API call is in progress
    this.loadingSubscription = this.store.select('loading').subscribe((loadingState) => {
      this.isLoading = loadingState.loadingStates['rfqSummary'] > 0;  // Set `isLoading` to true if loadingCount > 0
    });
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
      this.loggedInUser = user;
    });
    this.rfqSummary$ = this.store.select('rfqSummary');
    this.rfqSummary$
      .pipe(takeUntil(this.destroy$))
      .subscribe((summaryData: any) => {
        this.rfqSummaryDetails = summaryData as SourcingOutcomeInformation;
      });
    const navigation = this.router.getCurrentNavigation();
    this.rfqSummaryNumber = this.route.snapshot.params['id'] as string;
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.userList = dp.UserList as ExtendedKeycloakUser[];
        this.ReasonForAbortionDropDown=dp.RFQAbortReasons;
        this.userListSubject.next(this.userList);
        this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
      });
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user: UserInformation) => {
        if (user) {
          this.user = user;
          this.loadGetPurchaseExecutivesList();
          this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
        }
      });
    this.roName$ = this.store.select(state => state.rfqSummary.ROName);
    this.roName$.subscribe((roName) => {
      if (roName) {
        this.statusData.requestingOfficer = this.getuserName(roName);
      }
    });
    this.peName$ = this.store.select(state => state.rfqSummary.AssignedPE);
    this.peName$.subscribe((assignedPE) => {
      if (assignedPE) {
        this.statusData.assignedPE = this.getuserName(assignedPE);
      }
    });
    this.getReasonForNoQuotation();
    this.initializePurchaseAndSummaryData()
    if (navigation?.extras.state) {
      this.dataFromPrevious = navigation.extras.state['data'];
      this.breadCrumbFlow.push(this.dataFromPrevious?.fromRoute);
      this.MPDocumentNumber = this.dataFromPrevious.MPDocumentNumber;
      this.RFQNumber = this.dataFromPrevious.RFQNumber;
      this.getSummaryDetails(this.dataFromPrevious);
      this.getRFQItems();
    } else if (this.rfqSummaryNumber) {
      const page = sessionStorage.getItem('fromPage');
      if (page) this.breadCrumbFlow.push(page);
      else this.breadCrumbFlow.push('MyDocuments');
      this.getDraftSummary();
    }
  }

  async loadGetPurchaseExecutivesList() {
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    let data: PurchaseExecutives[];
    data = await lastValueFrom(this.BackendApi.getPurchaseExecutivesList(this.user?.userName))
    this.isUserPE = data.length >= 1 ? true : false;
    this.updateUserRole();
    this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
  }

  openSnackBar(notifMsg: string, type: string) {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: "top",
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 3000
    });
  }

  updateAllItemsHavePO(allItemsHavePo: boolean) {
    this.isAllItemsHavePO = allItemsHavePo;
  }

  getuserName(id: string): string {
    const user = this.userList.find((user) => user.id === id);
    return user?.last_name ?? '';
  }

  updateUserRole(action?: string) {
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    let userRoleFromKeyCloak = this.keycloakService.getUserRoles();
    const { fullName } = this.user;
    const { requestingOfficer, assignedPE } = this.statusData;

    if (fullName && requestingOfficer && assignedPE) {
      if (action === 'reassigned' && !this.isUserPE && fullName !== requestingOfficer) {
        this.router.navigate(['/land']);
        return;
      } else if (!action && !this.isUserPE && fullName !== requestingOfficer && !userRoleFromKeyCloak.includes('MP_RFQ_SUMMARY_READ_ALL')) {
        this.router.navigate(['/unauthorized']);
        return;
      } 

      if (fullName === requestingOfficer && fullName === assignedPE) {
        this.userRoleOnRfqSummary = RFQSummaryRole.Both_PE_RO;
      } else if (fullName === requestingOfficer) {
        this.userRoleOnRfqSummary = RFQSummaryRole.RO;
      } else if (this.isUserPE && fullName === assignedPE) {
        this.userRoleOnRfqSummary = RFQSummaryRole.Assigned_PE;
      } else if (this.isUserPE && fullName !== assignedPE) {
        this.userRoleOnRfqSummary = RFQSummaryRole.Other_PE;
      } else {
        this.userRoleOnRfqSummary = RFQSummaryRole.NONE;
        this.isReadOnlyRFQSummary = true;
      }
    }
    this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
  }

  async getSummaryDetails(dataFromPrevious: dataFromPrevious) {
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    try {
      const data: SourcingOutcomeInformation = await lastValueFrom(
        this.BackendApi.getRFQSummaryData(dataFromPrevious.MPDocumentNumber, dataFromPrevious.RFQNumber)
      );
      this.summaryData = JSON.parse(JSON.stringify(data));
      this.summaryData = {
        ...this.summaryData,
        CreatedBy: this.user?.userName,
        CreatedOn: new Date()
      }
      this.statusData = {
        rfqSummaryNum: '',
        assignedPE: this.getuserName(data?.AssignedPE),
        status: 'New',
        rfqNum: dataFromPrevious?.RFQNumber,
        requestingOfficer: this.getuserName(data?.ROName),
        createdBy: this.getuserName(this.user?.userName),
        documentNo: dataFromPrevious?.MPDocumentNumber,
        submittedOn: this.summaryData.CreatedOn,
        SecurityClassIdExt: data?.SecurityClassIdExt
      };
      this.vendorList = this.summaryData?.VendorsList;
      this.store.dispatch(
        updateRFQSummaryData({ rfqSummary: data })
      );
      this.store.dispatch(updateDocumentStatusId({ DocumentStatusId: 1 }));
      this.checkForQuoteExpired();
      this.updateUserRole();
    } catch (e) {
      console.log("Unable to load RFQ summary details");
      //throw e;
    }
    finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }
  }

  async getRFQItems() {
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    try {
      this.rfqItems = await lastValueFrom(
        this.BackendApi.getRFQItems(this.MPDocumentNumber, this.RFQNumber)
      );
    } catch (e) {
      console.log("Unable to load RFQ summary details");
    }
    finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }
  }

  async getReasonForNoQuotation() {
    try {
      const response: ReasonForNoQuotaionItem[] = await lastValueFrom(
        this.BackendApi.getReasonForNoQuotation()
      );
      this.reasonForNoQuotation = response.map(item => ({
        id: item.Code,
        value: item.Reason
      }));
    } catch (e) {
      console.log("Unable to retrieve the reasons for no quotation");
    }
  }

  handleBackButton = () => {
    const page = this.dataFromPrevious?.fromRoute ? this.dataFromPrevious?.fromRoute : sessionStorage.getItem('fromPage');
    const pageMapping: { [key: string]: string } = {
      [pageName.PE_Worklist]: '/peworklist',
      [pageName.My_Document]: '/land',
      [pageName.My_worklist]: '/worklist'
    };
    if (page && pageMapping[page]) {
      this.router.navigate([pageMapping[page]]);
    } else {
      this.router.navigate(['/land']);
    }
  };

  public get alertType(): typeof AlertType {
    return AlertType;
  }

  navigateToDocument() {
    let url: string = '';
    url = '/purchase/rfq/' + `${this.MPDocumentNumber}`;
    window.open(url, '_blank');
  }

  saveVendorList(vendorList: VendorsList[]): VendorsList[] {
    return vendorList.map(vendor => {
      if (!vendor.Id) vendor.Id = null;
      if (!vendor.QuoteExpiring) vendor.QuoteExpiring = null;
      if (!vendor.ReasonForNoQuotationId) vendor.ReasonForNoQuotationId = null;
      vendor.QuotationAttachment = vendor.QuotationAttachment.map(attachment => {
        if (!attachment.Id) attachment.Id = null;
        if (!attachment.AttachmentTypeId) attachment.AttachmentTypeId = null;
        if (attachment.IsStrikethrough === undefined || attachment.IsStrikethrough === null) attachment.IsStrikethrough = false;
        if (attachment.IsDeleted === undefined || attachment.IsDeleted === null) attachment.IsDeleted = false;
        return attachment;
      });
      return vendor;
    });
  }

  async saveSummaryDetails() {
    this.isSourcingOutcomeHasError = false;
    this.isVendorDocumentHasError = false;
    let saveResult: any;
    const saveRequest: SourcingOutcomeInformation = {
      "RFQSummaryNumber": this.rfqSummaryNumber ? this.rfqSummaryNumber : null,
      "RFQNumber": this.statusData?.rfqNum,
      "MPDocumentNumber": this.statusData?.documentNo,
      "CreatedBy": this.summaryData.CreatedBy,
      "CreatedOn": this.summaryData.CreatedOn,
      "ROName": this.rfqSummaryDetails.ROName,
      "AssignedPE": this.rfqSummaryDetails.AssignedPE,
      "SecurityClassIdExt": this.summaryData.SecurityClassIdExt,
      "VendorsList": this.saveVendorList(this.vendorList)
    }
    try {
      this.loadingMessage = "Saving Inprogress...";
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      saveResult = await lastValueFrom(
        this.BackendApi
          .saveRFQSummary(saveRequest)
          .pipe(takeUntil(this.destroy$))
      );
      this.openSnackBar('RFQ Summary Saved Successfully.', 'success');
      this.rfqSummaryNumber = saveResult.RFQSummaryNumber;
      this.router.navigateByUrl(`/rfqSummary/${this.rfqSummaryNumber}`);
      this.getDraftSummary();
    } catch (err:any) {
      this.openSnackBar(err, 'error');
    } finally {
      this.loadingMessage = '';
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }

  }
  async getDraftSummary() {
    this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
    try {
      const data: SourcingOutcomeInformation = await lastValueFrom(
        this.BackendApi.getRFQSummaryDraft(this.rfqSummaryNumber)
      );
      this.summaryData = JSON.parse(JSON.stringify(data));
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      this.userList$.subscribe(() => {
        if (this.userList.length > 0) {
          this.statusData = {
            rfqSummaryNum: this.rfqSummaryNumber,
            status: data?.DocumentStatusName ? data?.DocumentStatusName : 'Draft',
            rfqNum: data?.RFQNumber,
            documentNo: data?.MPDocumentNumber,
            submittedOn: data?.CreatedOn,
            assignedPE: this.getuserName(data?.AssignedPE),
            requestingOfficer: this.getuserName(data?.ROName),
            createdBy: this.getuserName(data?.CreatedBy),
            SecurityClassIdExt: data?.SecurityClassIdExt
          };
          this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
          this.updateUserRole();
        }
      });
      this.MPDocumentNumber = this.summaryData.MPDocumentNumber;
      this.RFQNumber = this.summaryData.RFQNumber;
      this.vendorList = this.summaryData?.VendorsList;
      this.activePage = this.rfqSummaryNumber;
      this.getRFQItems();
      if (data?.DocumentStatusId === 3 || data?.DocumentStatusId === 5 || data?.DocumentStatusId === 6) this.isReadOnlyRFQSummary = true;
      else this.isReadOnlyRFQSummary = false;
      this.store.dispatch(
        updateRFQSummaryData({ rfqSummary: data })
      );
      this.checkForQuoteExpired();
    } catch (e) {
      console.log("Unable to load RFQ summary draft");
    }
    finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }
  }

  validateSummaryDetails() {
    this.isSourcingOutcomeHasError = false;
    this.isVendorDocumentHasError = false;
    this.vendorList.forEach((vendor: VendorsList) => {
      if ((vendor.Status && !vendor.QuoteExpiring) || (!vendor.Status && !vendor.ReasonForNoQuotationId)) {
        this.isSourcingOutcomeHasError = true;
      }
      vendor.QuotationAttachment.forEach((attachment: QuotationAttachment) => {
        if (!attachment.AttachmentTypeId) {
          this.isVendorDocumentHasError = true;
        }
      });
    });
  }
  async submitSummaryDetails() {
    this.validateSummaryDetails();
    if (!this.isSourcingOutcomeHasError && !this.isVendorDocumentHasError) {
      //proceed to submit
      let submitResult: any;
      const submitRequest: SourcingOutcomeInformation = {
        "RFQSummaryNumber": this.rfqSummaryNumber ? this.rfqSummaryNumber : null,
        "RFQNumber": this.statusData?.rfqNum,
        "MPDocumentNumber": this.statusData?.documentNo,
        "CreatedBy": this.summaryData.CreatedBy,
        "CreatedOn": this.summaryData.CreatedOn,
        "ROName": this.rfqSummaryDetails.ROName,
        "AssignedPE": this.rfqSummaryDetails.AssignedPE,
        "SecurityClassIdExt": this.summaryData.SecurityClassIdExt,
        "VendorsList": this.saveVendorList(this.vendorList)
      }
      try {
        this.loadingMessage = "Submitting Inprogress...";
        this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
        submitResult = await lastValueFrom(
          this.BackendApi
            .submitRFQSummary(submitRequest)
            .pipe(takeUntil(this.destroy$))
        );
        this.openSnackBar('RFQ Summary Submitted Successfully.', 'success');
        this.rfqSummaryNumber = submitResult.RFQSummaryNumber;
        this.router.navigateByUrl(`/rfqSummary/${this.rfqSummaryNumber}`);
        this.getDraftSummary();
      } catch (err:any) {
        this.openSnackBar(err, 'error');
      }
      finally {
        this.loadingMessage = '';
        this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
      }
    }
  }

  // async recallSummaryDetails() {
  //   if (this.rfqSummaryNumber) {
  //     try {
  //       const data: SourcingOutcomeInformation = await lastValueFrom(
  //         this.BackendApi.getRFQSummaryDraft(this.rfqSummaryNumber)
  //       );

  //       if (data.DocumentStatusId !== 3) {
  //         console.warn('Recall is only allowed when status is Pending Evaluation.');
  //         return;
  //       }

  //       // Another condition to check if RO has raised at least one PO. Otherwise, this should be disabled.
  //       // this.canRecallRFQSummary = false;

  //       const recallResult = await lastValueFrom(
  //         this.BackendApi.recallRFQSummary({ RFQSummaryNumber: this.rfqSummaryNumber })
  //         .pipe(takeUntil(this.destroy$))
  //       );

  //       if (recallResult) {
  //         this.statusData.status = "Draft";
  //         this.isReadOnlyRFQSummary = false;
  //         this.getDraftSummary();
  //         console.log("RFQ Summary recalled successfully")
  //       }
  //     } catch (error) {
  //       console.log("Error recalling RFQ Summary", error)
  //     }
  //   }
  // }

  async initializePurchaseAndSummaryData() {
    try {
      await this.getPurchaseGroupIdInformation();
      await this.getMPRFQSummary();
    } catch (error) {
      console.error("Error during initialization:", error);
    }
  }

  async getPurchaseGroupIdInformation() {
    if (this.rfqSummaryNumber) {
      try {
        const response = await lastValueFrom(
          this.BackendApi
            .getPurchaseGroupIdInformation(this.rfqSummaryNumber)
            .pipe(takeUntil(this.destroy$))
        )
        if (response) {
          this.purchaseOrderGroups = response;
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("RFQ Summary Number is not available.")
    }
  }

  async getMPRFQSummary() {
    console.log("this.mpRFQSummary function is called");
    const summaryResponses: MPMMSInformation[] = [];
    try {
      if (this.purchaseOrderGroups.length > 0) {
        // Loop through each PurchaseOrderGroup and call the API
        for (const group of this.purchaseOrderGroups) {
          const response = await lastValueFrom(
            this.BackendApi.getMPRFQSummary(group.Id!).pipe(takeUntil(this.destroy$))
          );
          var filteredResponse = response.filter(mms => mms.ProcessStatusID !== 4 && mms.StateCode_POItem !== 'Inactive');
          //console.log("filtered response", filteredResponse);

          summaryResponses.push(...filteredResponse);
        }
        // console.log("THIS IS SUMMARY RESPONSES", summaryResponses);
        this.mpMmsInformation = summaryResponses;
        this.checkPOCreated();
        // console.log("All MPRFQ Summaries:", this.mpMmsInformation);
      } else {
        console.log("No Purchase Order Groups to process.");
      }
    } catch (error) {
      console.error("Unable to retrieve MPRFQ summaries", error);
    }
  }

  checkPOCreated(): void {
    this.store.dispatch(
      UpdatePOCreated({
        arePOCreated: this.mpMmsInformation.some((item: MPMMSInformation) => item.DocumentNumber)
      }));
  }

  openReassignDialog(): void {
    const dialogRef = this.dialog.open(ReassignDialogComponent, {
      data: {
        userRoleOnRfqSummary: this.userRoleOnRfqSummary,
        RFQSummaryNumber: this.rfqSummaryNumber,
        MPDocumentNumber: this.MPDocumentNumber
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateUserRole('reassigned');
      }
    });
  }

  openCompleteDialog(): void {
    // console.log('complete dialog all items have po', this.isAllItemsHavePO);
    const dialogRef = this.dialog.open(CompleteDialogComponent, {
      // width: this.isAllItemsHavePO ? '600px' : '1200px',
      // height: this.isAllItemsHavePO ? '240px' : '620px',
      width: '1200px',
      data: {
        type: "abort",
        rfqItems: this.rfqItems,
        mpMmsInformation: this.mpMmsInformation,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        // console.log("COMPLETE DIALOG IS CLOSED", result)
        const payload = {
          "RFQNumber": this.RFQNumber,
          "RFQSummaryNumber": this.rfqSummaryNumber,
          "MPDocumentNumber": this.MPDocumentNumber,
          "Items": (result.length > 0)
            ? result.map((item: any) => ({
              "Id": item.Id,
              "ReasonId": item.ReasonForAbort?.Id,
            }))
            : []
        }
        // console.log("payload", payload);
        this.completeRFQSummary(payload)
      }
    });
  }

  async openAbortRequestDialog(): Promise<void> {
    const dialogRef = this.dialog.open(RfqInfoDialogComponent, {
      width: '660px',
      data: {
        title: "Abort request",
        displaySubmit: true,
        type: RfqInfoDialogType.abort,
        displaySelection: {
          title: "Select reason for aborting your request if you do not wish to purchase all items.",
          selection: this.ReasonForAbortionDropDown,
          display: true
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.abortRFQSummary({
          "RFQSummaryNumber": this.rfqSummaryNumber,
          "AbortReasonId": result
        });
      }
    });
  }

  async recallRfqSummary() {
    const payload = {
      "RFQSummaryNumber": this.rfqSummaryNumber,
      "MPDocumentNumber": this.MPDocumentNumber
    };
    try {
      this.loadingMessage = 'Recall Inprogress...';
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      await lastValueFrom(
        this.BackendApi.recallRfqSummary(payload).pipe(
          takeUntil(this.destroy$),
          map((response) => {
            if (response.status === 200) {
              this.openSnackBar('RFQ summary Recall success.', 'success');
              this.getDraftSummary();
            }
          }),
          catchError((error) => {
            this.openSnackBar('RFQ failed to recall', 'error');
            throw error;
          })
        )
      );
    } finally {
      this.loadingMessage = '';
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }

  }

  breadcrumbsButtonActionHandler($event: any) {
    switch ($event.actionType as string) {
      case 'save-rfq-summary':
        this.saveSummaryDetails();
        break;
      case 'submit-rfq-summary':
        this.submitSummaryDetails();
        break;
      case 'reassign-rfq-summary':
        this.openReassignDialog();
        break;
      case 'recall-rfq-summary':
        this.recallRfqSummary();
        break;
      case 'complete-rfq-summary':
        this.openCompleteDialog();
        break;
      case 'abort-rfq-summary':
        this.openAbortRequestDialog();
        break;
      default:
        // do nothing
        break;
    }
  }

  handleRaisePO(payload: any) {
    if (payload) {
      this.raisePO(payload);
    } else {
      console.warn("Raise PO failed: payload missing.");
    }
  }

  async raisePO(payload: any): Promise<void> {
    try {
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      const result: any = await lastValueFrom(
        this.BackendApi.raiseRFQSummaryPO(payload)
      );
      const purchasegroupid = result?.body?.PurchaseOrderGroupId;
      const url = environment.mmsURL + environment.CreatePOPath + `${purchasegroupid}`;
      window.open(url, '_blank');

      this.getMPRFQSummary()  //newly added code for task-2490

    } catch (e: any) {
      console.warn("Raise PO API failed: " + e?.message);
    } finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }
  }

  async abortRFQSummary(payload: any): Promise<void> {
    try {
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      await lastValueFrom(
        this.BackendApi.abortRFQSummary(payload)
      );
    } catch (e: any) {
      console.warn("Raise PO API failed: " + e?.message);
    } finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
      // refresh page
      this.getDraftSummary();
    }
  }

  async completeRFQSummary(payload: any): Promise<void> {
    try {
      this.store.dispatch(incrementLoading({ context: 'rfqSummary' }));
      await lastValueFrom(
        this.BackendApi.completeRfqSummary(payload)
      );
      this.getDraftSummary();
    } catch (e) {
      console.warn("Complete RFQ Summary API failed: " + e);
    } finally {
      this.store.dispatch(decrementLoading({ context: 'rfqSummary' }));
    }
  }

  getInfoList(): string[] {
    let messages: string[] = [];

    if (this.userRoleOnRfqSummary == RFQSummaryRole.RO || this.userRoleOnRfqSummary == RFQSummaryRole.Both_PE_RO) {
      messages = [
        'Review all vendor documents and decide which vendor would you wish to purchase your items from',
        'Click “Abort request” if you do not wish to purchase all items',
        'Raise Purchase Order (PO) for items you wish to purchase',
        'Click "Complete" only when you have finished raising PO for all items that you wish to purchase',
      ];
    } else {
      messages = [
        'Quote expiry date',
        'If a vendor did not quote, the reason for no quotation',
        'Purpose of each vendor document',
        'Remove irrelevent vendor document, as needed',
      ];
    }

    return messages;
  }

  isDateExpired(row: VendorsList) {
    if (row.QuoteExpiring) {
      const currentDate = new Date();
      const currentDateOnly = new Date(currentDate.setHours(0, 0, 0, 0));
      const quoteExpiringDate = new Date(row.QuoteExpiring);
      const quoteExpiringDateOnly = new Date(quoteExpiringDate.setHours(0, 0, 0, 0));
      row.HavingExpiredQuote = quoteExpiringDateOnly < currentDateOnly;
    } else {
      row.HavingExpiredQuote = null;
    }
  }

  checkForQuoteExpired() {
    this.vendorList.forEach(vendor => this.isDateExpired(vendor));
    this.vendorsHavingExpiredQuote = this.vendorList
      .filter(vendor =>
        vendor.HavingExpiredQuote &&
        vendor.QuotationAttachment.some(file => !file.IsDeleted && !file.IsStrikethrough)
      )
      .map(vendor => vendor.Name);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.loadingSubscription.unsubscribe();
  }

}
